import React from 'react'
import CategoryRibbon from "../../components/CategoryRibbon"

export default function FlashcardsDecks(props) {
    let {category, flashcards, onShowDeck} = props
    let flashcardsNew = flashcards.filter(f => f.category === category && f.status === "new")
    let flashcardsReview = flashcards.filter(f => f.category === category && f.status === "review")
    let flashcardsMastered = flashcards.filter(f => f.category === category && f.status === "mastered")
    let hasNew = flashcardsNew.length > 0
    let hasReviewLater = flashcardsReview.length > 0
    let hasMastered = flashcardsMastered.length > 0
    let nofCardsNew = flashcardsNew.length
    let nofCardsReview = flashcardsReview.length
    let nofCardsMastered = flashcardsMastered.length
    let nofCardsInfoNew = nofCardsNew === 0 ? "No Cards" : nofCardsNew === 1 ? "1 Card": `${nofCardsNew} Cards`
    let nofCardsInfoReview = nofCardsReview === 0 ? "No Cards" : nofCardsReview === 1 ? "1 Card": `${nofCardsReview} Cards`
    let nofCardsInfoMastered = nofCardsMastered === 0 ? "No Cards" : nofCardsMastered === 1 ? "1 Card": `${nofCardsMastered} Cards`

    return (
        <div className="flashcards-decks-container">
            <CategoryRibbon category={category}/>
            <div className="container-fluid">
                <div className="row flashcards-decks-group">
                    <div className={`col-12 col-lg-4 flashcards-deck--col flashcards-deck--new ${!hasNew ? "disabled" : ""}`}>
                    <div className={`flashcards-deck`}>
                            <div className="flashcards-deck--inner">
                                <img width="170" height="170" alt="" src={`${process.env.PUBLIC_URL}/assets/images/icons/sections/icon-flash-play.svg`} />
                                <h3 className="flashcards-deck--title">New</h3>
                                <hr/>
                                <h4 className="flashcards-deck--numof">{nofCardsInfoNew}</h4>
                            </div>
                            <button className="btn btn--text-default btn--bg-light-blue" disabled={!hasNew} onClick={() => onShowDeck(category, "new")}>LAUNCH DECK</button>
                        </div>
                        <div className="flashcards-deck--status-row"></div>
                    </div>
                    <div className={`col-12 col-lg-4 flashcards-deck--col flashcards-deck--review ${!hasReviewLater ? "disabled" : ""}`}>
                        <div className={`flashcards-deck ${!hasReviewLater ? "disabled" : ""}`}>
                            <div className="flashcards-deck--inner">
                                <img width="170" height="170" alt="" src={`${process.env.PUBLIC_URL}/assets/images/icons/sections/icon-flash-review.svg`} />
                                <h3 className="flashcards-deck--title">Review Again</h3>
                                <hr/>
                                <h4 className="flashcards-deck--numof">{nofCardsInfoReview}</h4>
                            </div>
                            <button className="btn btn--text-default btn--bg-light-green" disabled={!hasReviewLater} onClick={() => onShowDeck(category, "review")}>LAUNCH DECK</button>
                        </div>
                        <div className="flashcards-deck--status-row">{!hasReviewLater && <p className="flashcards-deck--statusmsg">Mark flashcards for review to activate deck</p>}</div>
                    </div>
                    <div className={`col-12 col-lg-4 flashcards-deck--col flashcards-deck--complete ${!hasMastered ? "disabled" : ""}`}>
                        <div className={`flashcards-deck ${!hasMastered ? "disabled" : ""}`}>
                            <div className="flashcards-deck--inner">
                                <img width="170" height="170" alt="" src={`${process.env.PUBLIC_URL}/assets/images/icons/sections/icon-flash-star.svg`} />
                                <h3 className="flashcards-deck--title">Mastered</h3>
                                <hr/>
                                <h4 className="flashcards-deck--numof">{nofCardsInfoMastered}</h4>
                            </div>
                            <button className="btn btn--text-default btn--bg-light-purple" disabled={!hasMastered} onClick={() => onShowDeck(category, "mastered")}>LAUNCH DECK</button>
                        </div>
                        <div className="flashcards-deck--status-row">{!hasMastered && <p className="flashcards-deck--statusmsg">Mark flashcards as mastered to activate deck</p>}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}